import React, { useState } from 'react'
import { ToolTipWrap } from './style'

const CustomTooltip = ({ children, title, valign='top', align='center', className='' }) => {
  return (
    <ToolTipWrap className={`customTT ${className}`} data-title={title} valign={valign} align={align}>{children}</ToolTipWrap>
  )
}

export default CustomTooltip
